export const jobsTranslations = {
  JOBS_TITLE: 'Want to work at Tranzer?',
  JOBS_SUBTITLE: 'Join our dreamteam!',

  JOB_OFFER_HEADER: 'Job offer',
  JOB_OFFER_READ_MORE: 'Read more',
};
